// init
import menu from './components/menu.js';
import shrink from './components/shrink.js';
import customCursor from "./components/cursor.js";

// components
// import changeBG from "./components/changeBg";
import './components/button.js';
import changeBG from './components/changeBg.js';
import modalJobs from './components/modal-jobs.js';
import splideMarquee from './components/splideMarquee.js';

// blocks
import carousel from './blocks/carousel.js';
import carouselMedia from './blocks/carouselMedia.js';
import carouselSolid from './blocks/carouselSolid.js';
import productsCarousel from './blocks/productsCarousel.js';
import bannerFullscreen from './blocks/banner.js';
import { banner } from './blocks/banner.js';

// Helper function to conditionally initialize modules
const initIfExists = (selector, callback) => {
    if (document.querySelector(selector)) {
        callback();
    }
};

///////////////////////////////////////////////////////////////////////////////////

// before loaded
document.addEventListener('DOMContentLoaded', dcl);

// load
window.addEventListener('load', () => {

    // const loader = document.querySelector('.loading');

    // 	// setTimeout(() => {
    // 	// 	loader.classList.add('hidden');
    // 	// 	loader.addEventListener('transitionend', () => {
    // 	// 		loader.style.display = 'none';
    // 	// 	});
    // 	// }, 500);

    load();

});

// Window On Resize
window.addEventListener('resize', onResize);

// ///////////////////////////////////////////////////////////////////////////////////

function dcl() {
    // initIfExists("splide--fullscreen", splideFullscreen);

    shrink();
    customCursor();

    initIfExists(".card__job", modalJobs);
    initIfExists("#menu-open", menu);
    initIfExists(".cta_large", changeBG);
    initIfExists(".cta_center", changeBG);
    initIfExists(".banner_full_screen", bannerFullscreen);
    initIfExists(".banner", banner);
    // initIfExists(".cta_center", changeBG);    

}

function load() {
    initIfExists(".splide--carousel", carousel);
    initIfExists(".splide--carousel_media", carouselMedia);
    initIfExists(".splide--carousel_solid", carouselSolid);
    initIfExists(".splide--carousel_products", productsCarousel);
    initIfExists(".splide--marquee", splideMarquee);
}

function onResize() { }